module.exports = __webpack_public_path__ + "img/bermuda.320461fa.svg";